import {
    POST,
    GET
} from "../util";
const receivablesUrl = "api/seller-all-receivables-inspection/";
import APP from "../appConfig";

const url = {
    list: `${receivablesUrl}list`,
    details: `${receivablesUrl}details`,
    downloadAllDocuments: `${receivablesUrl}download-all-documents`,
    // export-csv/{fromDate}/{toDate}/{fileType}
    // date format: dd-MM-yyyy
    // file types [csv, xlsx]
    exportCsv: `${receivablesUrl}export-csv`,


};
const allReceivablesApi = {
    list: (params = {}) => {
        return POST(url.list, params);
    },
    details: (params = {}) => {
        return GET(url.details, params);
    },
    downloadAllDocuments: (params = {}) => {
        return POST(url.downloadAllDocuments, params);
    },
    exportCsvUrl: (params = {}) => {
        return APP.DOMAIN + url.exportCsv + '/' + params.fromDate + '/' + params.toDate + '/' + params.fileType;
    },
};
export {
    allReceivablesApi
};